export default {
  /**
   * Data properties shared between all compoinents
   */
  data () {
    return {
      value: null,
      isDirty: false,
      hideValidationUi: false,
      isField: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/data.js